import { applyStyle } from '../css';
export function createCard(opts = {}) {
    const card = document.createElement('section');
    applyStyle(card, {
        background: 'var(--bg-elev-2)',
        border: opts.accent ? '1px solid var(--accent)' : '1px solid var(--border-subtle)',
        borderRadius: 'var(--radius-md)',
        padding: opts.padding ?? 'var(--sp-5)',
        boxShadow: 'var(--shadow-card)',
        transition: 'border-color var(--motion-fast)',
    });
    if (opts.title || opts.headerRight) {
        const header = document.createElement('div');
        applyStyle(header, {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 'var(--sp-3)',
            marginBottom: 'var(--sp-3)',
        });
        const titleBox = document.createElement('div');
        applyStyle(titleBox, { display: 'flex', flexDirection: 'column', gap: '2px', flex: '1' });
        if (opts.caption) {
            const cap = document.createElement('div');
            cap.textContent = opts.caption;
            applyStyle(cap, {
                fontSize: 'var(--fs-tiny)',
                color: 'var(--text-tertiary)',
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
            });
            titleBox.append(cap);
        }
        if (opts.title) {
            const title = document.createElement('h3');
            title.textContent = opts.title;
            applyStyle(title, {
                margin: '0',
                fontSize: 'var(--fs-h3)',
                fontWeight: '600',
                color: 'var(--text-primary)',
            });
            titleBox.append(title);
        }
        if (opts.subtitle) {
            const sub = document.createElement('div');
            sub.textContent = opts.subtitle;
            applyStyle(sub, {
                fontSize: 'var(--fs-caption)',
                color: 'var(--text-secondary)',
            });
            titleBox.append(sub);
        }
        header.append(titleBox);
        if (opts.headerRight)
            header.append(opts.headerRight);
        card.append(header);
    }
    if (opts.children)
        for (const c of opts.children)
            card.append(c);
    return card;
}
